import React, {useEffect} from 'react';
import {Dimensions, Image, Text, TouchableOpacity, View} from 'react-native';
import DomainSelectionCss from "./DomainSelectionCss";
import i18n from "../../services/i18n";
import {navigationService} from "../../services/NavigationService";
import {getRedirectionUrl} from "./DomainSelectionFunctions";
import hounslowLogo from '../../assets/images/hounslow/logoMain.png';
import knowsleyLogo from '../../assets/images/knowsley/logoMain.png';
import lambethLogo from '../../assets/images/lambeth/logoMain.png';
import oldhamLogo from '../../assets/images/oldham/logoMain.png';
import defaultLogo from '../../assets/images/ccp/logoMain.png';

const DomainSelectionView = ({navigation}: any) => {

    let isLowDimension = Dimensions.get('window').width < 500;
    const styles = DomainSelectionCss(isLowDimension);
    const i18title = i18n.t("items.title");
    const i18copyRightText = i18n.t("items.copyRightText");
    let itemsList = [];
    let domains = navigationService.getDomainList();
    let redirectionUrl = getRedirectionUrl();
    const logos: Record<string, any> = {
        hounslow: hounslowLogo,
        knowsley: knowsleyLogo,
        lambeth: lambethLogo,
        oldham: oldhamLogo,
        common: defaultLogo,
    };

    useEffect(() => {
    }, []);

    for (let i = 0; i < domains.length; i++) {
        itemsList.push(
            <TouchableOpacity style={{margin: isLowDimension ? "1%" : "3%"}} key={i} onPress={() => {
                window.open("https://" + domains[i] + redirectionUrl, '_self')
            }}>
                <Image style={styles.logoSelection}
                       source={logos[domains[i]]}
                       resizeMode="center"
                />
            </TouchableOpacity>
        )
    }

    return (
        <View style={styles.body}>
            <View style={styles.rowItemTitle}>
                <Image style={styles.logo}
                       source={require('../../assets/images/ccp/logo.png')}
                       resizeMode="center"
                />
                <h1 style={styles.form___h1}>{i18title}</h1>
            </View>
            <View style={styles.form}>
                <View style={styles.selectionBox}>
                    {itemsList}
                </View>
            </View>
            <View style={styles.viewFooter}>
                <Text style={styles.footerText}>{i18copyRightText}</Text>
            </View>
        </View>
    );
};

export default DomainSelectionView;

